import React from "react";
import style from "./style.less";
import { LanguageContext } from "@/data/LanguageProvider";
import { useContext, useEffect, useState } from "react";
const WithdrawLogShow = (props) => {
    const { langText } = useContext(LanguageContext);
    return (
        <div
            class={`${style.info} ${props.k === 9 || props.k + 1 === props.length ? style.end_i : ""
                }`}
        >
            <div class={`${style.info_time} ${props.k === 0 ? style.first_i : ""}`}>
                {props.info.time}
            </div>
            <div class={`${style.info_amount} ${props.k === 0 ? style.first_i : ""}`}>
                {props.info.amount}
            </div>
            <div class={`${style.info_status} ${props.k === 0 ? style.first_i : ""}`}>
                {langText(props.info.status)}
            </div>
        </div>
    );
};

export default WithdrawLogShow;
